export const StorageKeys = {
  firstPage: 'sf_first_page',
  marketingUrl: 'sf_marketing_url',
  history: 'sf_history',
  ref: 'sf_referrer',
  refDomain: 'sf_referrng_domain',

  abData: 'sf_ab_data',
  abCid: 'sf_ab_cid',
  variantToSet17477: 'variant_to_set_17477',

  questionnairePosition: 'sf_lq_position',
  questionnaireChoices: 'sf_lq_choices',
  questionnaireBooks: 'sf_lq_books',
  offerGuide: 'sf_17817_offer_guide',
  selectedPlanId20676: 'sf_20676_selected_plan_id',
  resolvedTitle20676: 'sf_20676_resolved_title',
  interestBook20676: 'sf_20676_interest_book',

  authToken: 'auth_token',
  user: 'user',
  previouslyLogin: 'previously_logged_in',

  changelog: 'sf_changelog',
  nightMode: 'sf_night_mode',
  weglotStoredLang: 'wglang',
  position: 'sf_position',
  notificationsCtaTiming: 'sf_notifications_cta_timing',

  bannerDismissed17477: 'sf_17477_banner_dismissed',
  popupDismissed17477: 'sf_17477_popup_dismissed',

  iosConsentSetting: 'iosConsentSetting',
  playerVolume: 'sf_player_volume',
  playerRate: 'sf_player_rate',
  capacitorUid: '_capuid',
  offlineAnnotations: 'offline_annotations',
  annotator: 'sf_annotator',
  cancelDiscount: 'sf_cancel_discount',
  tutorialAutoShow: 'sf_tutorial_auto_show',
  readingSettings: 'sf_reading_settings',
  needsUpdate: 'sf_needs_update',
  onboardingQuestionStep: 'sf_oq_step',

  checklistProgress19055: 'sf_checklist_progress',
  checklistIsCollapsed19055: 'sf_checklist_is_collapsed',
  checklistFirstDoc19055: 'sf_checklist_first_doc',
  guideCompletionPending19383: 'sf_guide_completion_pending_19383',

  /** See `UpgradePromptState` in `models/billing.upgrade.prompt.ts`. */
  upgradePromptState: 'sf_upgrade_prompt_state',
  upgradePromptPagesVisited: 'sf_upgrade_prompt_pages_visited',

  partnerCreatorSession: 'sf_partner_creator',

  // Stored string stays so users who already saw the popup are not shown it again.
  hesitationDiscountShown: 'sf_18997_hesitation_discount_shown',
  exitIntentShown19129: 'sf_19129_exit_intent_shown',

  homepageHeroGoalSelectedValue19253: 'sf_19253_homepage_hero_selected_value',
  homepageHeroGoalOnboardingStarted19253:
    'sf_19253_homepage_hero_onboarding_started',
} as const

export type StorageKey = (typeof StorageKeys)[keyof typeof StorageKeys]
